import {styled} from '@mui/material/styles';
import {Fragment, ReactNode} from 'react';

const SContainer = styled('div')(({theme}) => ({
  display: 'grid',
  gridAutoFlow: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const SDotSeparator = styled('span')(({theme}) => ({
  width: 3,
  height: 3,
  borderRadius: '50%',
  background: theme.palette.text.secondary,
}));

export const SeparatedLabel = ({labels}: {labels: ReactNode[]}) => {
  return (
    <SContainer>
      {labels.map((label, index) => (
        <Fragment key={index}>
          <span>{label}</span>
          {index !== labels.length - 1 && <SDotSeparator />}
        </Fragment>
      ))}
    </SContainer>
  );
};
